import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-software-label',
  templateUrl: './software-label.component.html',
  styleUrls: ['./software-label.component.scss']
})
export class SoftwareLabelComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
